import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  sessions: [],
  currentPage: null
}

const mutations = {  
  SET_SESSIONS (state, payload) {
    state.sessions = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }  
}

const actions = {
  sessionList: (context, data) => {
    let query = '?'    
    for (let f in data) {       
      if (Array.isArray(data[f])) {
        for (let element of data[f]) {                 
          query += `&${f}[]=${element}`
        }
      } else {          
        query += `&${f}=${data[f]}`
      }
    }
    
    return Vue.http.get(`${env.API}/api/session{query}`)    
      .then((response) => {        
        context.commit('SET_SESSIONS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createSession: (context, data) => {
    return Vue.http.post(`${env.API}/api/session`, data)
      .then((response) => {
        context.commit('SET_SESSIONS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  mySessions: (context, data) => {
    return Vue.http.post(`${env.API}/api/session/my-sessions`, data)
      .then((response) => {
        context.commit('SET_SESSIONS', response.body)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updatePersonalDevelopment: (context, data) => {
    return Vue.http.post(`${env.API}/api/session/update`, data)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getMyTeamSessions: (context, data) => {
    console.log(data);
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }
    if (data.year) {
      query += `&year=${data.year}`      
    }
    console.log(query);
    return Vue.http.get(`${env.API}/api/session/my-team-sessions/${data.id}${query}`)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  userHistorySessions: (context, data) => {
    return Vue.http.post(`${env.API}/api/session/user-sessions-history`, data)
      .then((response) => {
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  sessionsByYear: (context) => {
    return Vue.http.get(`${env.API}/api/session/number/sessions/per-year`)
      .then((response) => {
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateSession: (context, data) => {
    return Vue.http.post(`${env.API}/api/session/update`, data)
      .then((response) => {
        context.commit('SET_SESSIONS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  },
  sessionsReport: (context, data) => {
    return Vue.http.get(`${env.API}/api/session/report/${data.year}/${data.period}`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getSessions: (state) => state.sessions
}

export const session = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/session.js